"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypesExtra = require("prop-types-extra");

var _Alert = _interopRequireDefault(require("react-bootstrap/Alert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
  }));
};

CheckIcon.defaultProps = _defineProperty({
  focusable: "false",
  'aria-hidden': "true",
  fill: "#666",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, "focusable", 'false');

var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
  }));
};

WarningIcon.defaultProps = _defineProperty({
  focusable: "false",
  'aria-hidden': "true",
  fill: "#666",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, "focusable", 'false');

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  }));
};

InfoIcon.defaultProps = _defineProperty({
  focusable: "false",
  'aria-hidden': "true",
  fill: "#666",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, "focusable", 'false');

var Alert = function Alert(_ref) {
  var variant = _ref.variant,
      accessibilityLabel = _ref.accessibilityLabel,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["variant", "accessibilityLabel", "children"]);

  var icon = {
    success: CheckIcon,
    warning: WarningIcon,
    danger: WarningIcon,
    info: InfoIcon
  };
  var IconComponent = icon[variant];
  return /*#__PURE__*/_react["default"].createElement(_Alert["default"], _extends({
    variant: variant
  }, props), accessibilityLabel && /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, accessibilityLabel), /*#__PURE__*/_react["default"].createElement(IconComponent, {
    className: "uxf-alert-icon"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uxf-alert-content"
  }, children));
};

exports.Alert = Alert;
Alert.propTypes = {
  /**
   * Change the underlying component CSS base class name and modifier class names prefix
   * @default 'alert'
   */
  bsPrefix: _propTypes["default"].string,

  /**
   * The Alert visual variant
   *
   * `"success"` `"danger"` `"warning"` `"info"`
   */
  variant: _propTypes["default"].string.isRequired,

  /**
   * Renders a properly aligned dismiss button, as well as
   * adding extra horizontal padding to the Alert.
   */
  dismissible: _propTypes["default"].bool,

  /**
   * Controls the visual state of the Alert.
   *
   * @controllable onClose
   */
  show: _propTypes["default"].bool,

  /**
   * Callback fired when alert is closed.
   *
   * @controllable show
   */
  onClose: _propTypes["default"].func,

  /**
   * Sets the text for alert close button.
   */
  closeLabel: _propTypes["default"].string,

  /**
   * Animate the alert dismissal. Defaults to using `<Fade>` animation or use
   * `false` to disable. A custom `react-transition-group` Transition can also
   * be provided.
   */
  transition: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypesExtra.elementType]),

  /**
   * Sets the label for assistive technology tools
   */
  accessibilityLabel: _propTypes["default"].string
};
Alert.defaultProps = {
  variant: "success"
};